import {
  IC_PERMISSION_COVER,
  COLLABSTR_DESIGN_SYSTEM_COVER,
} from "./caseStudyMedia";

/** UI stills for the “Work at a glance” lightbox. Append objects here as new shots land. */
export const GLANCE_UIS = [
  {
    src: COLLABSTR_DESIGN_SYSTEM_COVER,
    title: "Collabstr: design system (condo)",
  },
  {
    src: "https://res.cloudinary.com/dlzvz9qj8/image/upload/v1782966059/Homepage_Feature_Landing_Pages_cssxo2.png",
    title: "Collabstr: homepage system",
  },
  {
    src: "https://res.cloudinary.com/dlzvz9qj8/image/upload/v1782966051/Use_Cases_tbgakm.png",
    title: "Collabstr: use cases",
  },
  {
    src: "https://res.cloudinary.com/dlzvz9qj8/image/upload/v1782966043/Case_Studies_pclkbo.png",
    title: "Collabstr: case studies",
  },
  {
    src: "https://res.cloudinary.com/dlzvz9qj8/image/upload/v1782966034/Retention_Magnifiers_uaung9.png",
    title: "Collabstr: campaign SOP",
  },
  {
    src: "https://res.cloudinary.com/dlzvz9qj8/image/upload/v1782966015/Creator_Onboarding_rt7lgu.png",
    title: "Collabstr: creator onboarding",
  },
  {
    src: "/glance/collabstr-instagram-reel.jpg",
    title: "Collabstr: Instagram reel",
    href: "https://www.instagram.com/reel/DduqUGjPvdl/",
  },
  {
    src: IC_PERMISSION_COVER,
    title: "IC 3.0: permission flow",
  },
  {
    src: "https://res.cloudinary.com/dlzvz9qj8/image/upload/v1744798531/App_Permissions_vhrqub.png",
    title: "IC 3.0: app permissions",
  },
  {
    src: "https://res.cloudinary.com/dlzvz9qj8/image/upload/v1744798527/Folder_Permissions_gtplp0.png",
    title: "IC 3.0: folder permissions",
  },
  {
    src: "https://res.cloudinary.com/dlzvz9qj8/video/upload/v1792976602/ic-design-system-stack_xmdjgn.mp4",
    title: "IC 3.0: design system",
  },
  {
    src: "https://res.cloudinary.com/dlzvz9qj8/image/upload/v1741833725/Colour_styles_1_buzv9s.png",
    title: "IC 3.0: colour styles",
  },
  {
    src: "/glance/ic-connect-platform.jpg",
    title: "IC: Connect platform (website)",
  },
  {
    src: "/glance/ic-document-policy.png",
    title: "IC 3.0: document & policy",
  },
  {
    src: "/glance/ic-website-refresh-12.png",
    title: "IC: website refresh product shot",
  },
  {
    src: "/glance/ic-reach-conference.jpg",
    title: "IC: REACH conference demo",
  },
  {
    src: "https://res.cloudinary.com/dlzvz9qj8/video/upload/v1792984001/hsp-app-showcase_wbuuxg.mp4",
    title: "HSP Planet",
  },
  {
    src: "https://res.cloudinary.com/dlzvz9qj8/image/upload/v1761290126/Creatable_Investment_Pitch_Template___56_qwbmuq.jpg",
    title: "SAM",
  },
];

/** DomeGallery: { src, alt } */
export const GLANCE_DOME_IMAGES = GLANCE_UIS.map(({ src, title, href }) => ({
  src,
  alt: title,
  href: href || "",
}));
